import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { useSettings, track } from "@/lib/api";
import { MarketTape } from "@/components/market/MarketTape";

const LINKS = [
  ["Programs", "/programs"], ["Learning Paths", "/learning-paths"], ["Market Lab", "/market-lab"], ["Mentors", "/mentors"],
  ["NISM", "/nism"], ["Events", "/events"], ["Resources", "/resources"], ["About", "/about"], ["Contact", "/contact"],
];

export const Logo = ({ dark, className = "h-12 sm:h-14" }) => (
  <Link to="/" data-testid="nav-logo" className="flex items-center group" aria-label="The House of Trading — Home">
    <img src={dark ? "/logo-dark.png" : "/logo-white.png"} alt="The House of Trading" width={583} height={200} className={`${className} w-auto transition-opacity group-hover:opacity-90`} />
  </Link>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { data: s } = useSettings();
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  const ann = s?.announcement;
  return (
    <header className="sticky top-0 z-50 glass">
      {ann?.enabled && (
        <div data-testid="announcement-bar" className="hidden md:block border-b border-white/5 bg-[#0B1324] text-center text-xs text-slate-300 py-1.5">
          <span className="font-mono text-[var(--cyan)] mr-2">●</span>{ann.text}{ann.link && <Link to={ann.link} className="ml-2 text-[var(--blue)] hover:underline">Learn more →</Link>}
        </div>
      )}
      <MarketTape compact />
      <nav className="container-x flex h-[72px] items-center justify-between gap-3" aria-label="Primary">
        <Logo />
        <ul className="hidden xl:flex items-center gap-6">
          {LINKS.map(([l, to]) => (
            <li key={to}><NavLink to={to} data-testid={`nav-${l.toLowerCase().replace(/\s/g, "-")}-link`} className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[var(--blue)] ${isActive ? "text-[var(--blue)]" : "text-slate-300"}`}>{l}</NavLink></li>
          ))}
        </ul>
        <div className="flex items-center gap-3">
          <Link to="/learning-paths" data-testid="nav-find-program-cta" className="btn btn-primary hidden md:inline-flex !py-2.5 whitespace-nowrap" onClick={() => track("cta_click", { cta: "nav_find_program" })}>Find Your Program <ArrowRight size={16} /></Link>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="xl:hidden grid h-10 w-10 place-items-center rounded-lg border border-white/10 text-slate-200" aria-label="Toggle menu">{open ? <X size={20} /> : <Menu size={20} />}</button>
        </div>
      </nav>
      {open && (
        <div data-testid="mobile-menu" className="xl:hidden border-t border-white/10 bg-[#070C18] px-4 pb-6 pt-3">
          <ul className="grid grid-cols-2 gap-1">
            {LINKS.map(([l, to]) => <li key={to}><NavLink to={to} className="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-200 hover:bg-white/5">{l}</NavLink></li>)}
          </ul>
          <Link to="/book-counselling" data-testid="mobile-menu-counselling-cta" className="btn btn-primary mt-4 w-full">Book Counselling</Link>
        </div>
      )}
    </header>
  );
};
